module.exports = __webpack_public_path__ + "img/info-icon.ce5239b4.svg";